import getApi from '../../api'

export const deletePatient = (id: number) => getApi().delete<void>(`/patients/${id}`)
